import React, {useContext} from 'react'
import { useHistory } from 'react-router-dom'

import { CHART_TYPES, CHART_TYPE_LABELS, ICM_CHART_TYPES } from '../../mock'

const CashGameMultiway = ({setIsSeqModeExpanded, setIsFiltersExpanded}) => {
  return (
    <div
      onClick={() => {
        setIsSeqModeExpanded(true)
        setIsFiltersExpanded(false)
      }}
      className="PreflopCharts__button sequence-mode-button"
      style={{borderWidth: 0, maxWidth: "100%", order: 3}}
    >
      <div className="PreflopCharts__button-label">
        Cash Game Multiway
      </div>
    </div>
  )
}

export const ChartTypes = ({selectedFilters, setSelectedFilters, setIsSeqModeExpanded, setIsFiltersExpanded}) => {

  const onPress = (item) => {
    setSelectedFilters({ ...selectedFilters, chartType: item })
    history.push(`/charts/gto?type=${item.split(' ').join('').toLowerCase()}`)
  }
  const history = useHistory()

  return (
    <div className="PreflopCharts__options">
      <p>Chart types</p>
      <div className="PreflopCharts__options-row">
        {Object.entries(CHART_TYPES).map(([value, label], idx) => {
          const isSelected = value === selectedFilters.chartType
          return (
            <div
              key={value}
              onClick={() => {
                // actid=31
                window.analytics?.track('chart_type:click', {
                  type: value,
                })

                onPress(value)
              }}
              className="PreflopCharts__button"
              style={{
                borderWidth: isSelected ? '2px' : 0,
                order: idx,
              }}
            >
              <div className="PreflopCharts__button-label">
                {CHART_TYPE_LABELS[value]}
              </div>
            </div>
          )
        })}
        {Object.entries(ICM_CHART_TYPES).map(([label, value], idx) => {
          const isSelected = label === selectedFilters.chartType
          return (
            <div
              key={value}
              onClick={() => {
                // actid=31
                window.analytics?.track('chart_type:click', {
                  type: value,
                })

                history.push(`/charts/icm?type=${value}`)
              }}
              className="PreflopCharts__button"
              style={{
                borderWidth: isSelected ? '2px' : 0,
                order: idx + 6,
              }}
            >
              <div className="PreflopCharts__button-label">{label}</div>
            </div>
          )
        })}
        <CashGameMultiway
          key={'cash-game-multiway'}
          setIsSeqModeExpanded={setIsSeqModeExpanded}
          setIsFiltersExpanded={setIsFiltersExpanded}
        />

      </div>
    </div>
  )
}
